import { GameCardConfiguration } from '../../gamesConfiguration';
import {
    step10map,
    step11bucky,
    step12buckyProblem,
    step13map,
    step14annabeth,
    step15janus,
    step16januscipher,
    step17medusa,
    step18medusacipher,
    step19sphinx,
    step1intro,
    step20sphinx,
    step21sphinx,
    step22geryon,
    step23geryoncipher,
    step24kalypso,
    step25kalypsocipher,
    step26hades,
    step27hadescipher,
    step28map,
    step29door,
    step2jost,
    step30door,
    step31map,
    step32littleprince,
    step33littleprince,
    step34tinder,
    step35end,
    step3saruman,
    step4noteIntro,
    step5note,
    step6map,
    step7wineryIntermission,
    step8winery,
    step9wineryProblem,
} from './steps';
import gameBackground from '../../../assets/images/games/m-game/game-preview.webp';

export const mGameNumberSteps = [1000];
export const mGameContentConfiguration: MGameConfiguration = {
    cardConfiguration: {
        title: 'Tajomný odkaz',
        subtitle: 'od Hansa a Pusheen',
        background: gameBackground,
        gameUrl: '/m-hra',
        showValidity: false,
    },
    gameConfiguration: [
        { id: 0 },
        step1intro,
        step2jost,
        step3saruman,
        step4noteIntro,
        step5note,
        step6map,
        step7wineryIntermission,
        step8winery,
        step9wineryProblem,
        step10map,
        step11bucky,
        step12buckyProblem,
        step13map,
        step14annabeth,
        step15janus,
        step16januscipher,
        step17medusa,
        step18medusacipher,
        step19sphinx,
        step20sphinx,
        step21sphinx,
        step22geryon,
        step23geryoncipher,
        step24kalypso,
        step25kalypsocipher,
        step26hades,
        step27hadescipher,
        step28map,
        step29door,
        step30door,
        step31map,
        step32littleprince,
        step33littleprince,
        step34tinder,
        step35end,
    ],
};

export type MGameCipher = {
    text?: string;
    images?: any[];
    isPathFinder?: boolean;
    custom?: any;
    snowImages?: any[];
    snowSelectionText?: string;
    label?: string;
};

export type MGameHint = {
    text?: string;
    image?: any;
    html?: string;
    solution?: boolean;
};

export type MGameStepConfiguration = {
    id: number;
    title?: string;
    taskText?: string;
    codeInputText?: string;
    codeInputPassCodeRegexp?: string;
    additionalInfo?: string;
    cipher?: MGameCipher;
    continueButtonText?: string;
    codeInputPassCodeCommonMistakeRegexp?: [string];
    codeInputPassCodeCommonMistakeMessage?: [string];
    isMap?: boolean;
    mapPlace?: number;
    mapImage?: any;
    diaryIcon?: boolean;
};

export type MGameGameConfiguration = MGameStepConfiguration[];

export type MGameConfiguration = {
    cardConfiguration: GameCardConfiguration;
    gameConfiguration: MGameGameConfiguration;
};
